export default __webpack_public_path__ + "static/media/filter-3.21755bab.png";